export default __webpack_public_path__ + "static/media/desktop-feature-4.74f3e85c.png";